/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../../node_modules/@types/kendo-ui/index.d.ts" />


export class RegisterUserPage {

    public static Init() {

        $("#Input_PhoneNumber").kendoMaskedTextBox({ mask: "(000) 000-0000" });
        $("#Input_CellPhoneNumber").kendoMaskedTextBox({ mask: "(000) 000-0000" });
        $("#Input_ZipCode").kendoMaskedTextBox({ mask: "00000" });

        var stateCode: string = $('#Input_StateCode').val() as string;
        RegisterUserPage.UpdateStatesList(stateCode);
        RegisterUserPage.UpdateZipCode();

        $('#Input_Country').on("change", () => {
            RegisterUserPage.UpdateStatesList(stateCode);
            RegisterUserPage.UpdateZipCode();
        });

        $("input:radio[name='Input.RoleType']").on("change", () => {
            RegisterUserPage.RoleChanged();
        });

    }

    private static RoleChanged() {
        var userRole = $("input:radio[name='Input.RoleType']:checked").val()
        if (userRole == "Contractor") {
            $("#div-manual-company").removeClass("d-none").slideDown('slow');
        }
        else {
            $("#div-manual-company").slideUp('slow');
            RegisterUserPage.ClearCompanySelectFields();
        }
    }

    private static ClearCompanySelectFields() {
        //Clear company selection
        $('#div-manual-company input[type=text]').each(function () {
            $(this).val('');
        });
    }

    private static UpdateStatesList(selectedState) {
        $('#Input_StateCode').empty();

        var selectedCountry: string = $('#Input_Country').val() as string;
        if (selectedCountry) {
            var url = `${window.location.origin}/api/State/list?country=${selectedCountry}`;
            $.get(url, (result) => {
                for (let state in result) {
                    if (result[state] === selectedState) {
                        $('#Input_StateCode').append('<option value="' + result[state] + '" selected="selected">' + state + '</option>');
                    } else {
                        $('#Input_StateCode').append('<option value="' + result[state] + '">' + state + '</option>');
                    }
                }
            });
        }
        $('#Input_StateCode').prepend('<option value="" selected="selected">-- Select --</option>', "0");
    }

    private static UpdateZipCode() {
        var maskedtextbox = $("#Input_ZipCode").data("kendoMaskedTextBox");
        $("#Input_ZipCode").val('');

        if ($('#Input_Country').val() === "United States") {
            maskedtextbox.setOptions({ mask: "00000" });
        } else if ($('#Input_Country').val() === "Canada") {
            maskedtextbox.setOptions({ mask: "L0L 0L0" });
        }
    }

}

((window: any, document: any) => {
    $(() => {
        RegisterUserPage.Init();
    });
})(window, document);